import { render, staticRenderFns } from "./NewsStore.vue?vue&type=template&id=10cc0568&"
import script from "./NewsStore.vue?vue&type=script&lang=js&"
export * from "./NewsStore.vue?vue&type=script&lang=js&"
import style0 from "./NewsStore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports